// Screens
import { ApmProvider } from '../types/common'
import { cdnLink } from '../helpers/cdn'

export enum Screens {
  CREDENTIALS = 'CREDENTIALS',
  PIN = 'PIN',
  PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
  CONFIRMATION = 'CONFIRMATION',
  POCKETS = 'POCKETS',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  SUCCESS_REJECT = 'SUCCESS_REJECT',
  PAYMENT = 'PAYMENT',
  FUNDS_CONFIRMATION = 'FUNDS_CONFIRMATION',
}

// Fetch States

export enum FetchStates {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}

// Consents

export enum Consents {
  PAYMENT = 'payment',
  ACCOUNT = 'account',
  FUNDS_CONFIRMATION = 'funds-confirmation',
}

// Funds Confirmation schemes

export enum FundsConfirmationSchemes {
  SORT_AND_ACCOUNT = 'UK.OBIE.SortCodeAccountNumber',
  IBAN = 'UK.OBIE.IBAN',
}

// Local storage

export enum LocalStorageKeys {
  ACCESS_TOKEN = 'AT',
  VERIFICATION_TOKEN = 'VT',
}

export enum Keys {
  BACKSPACE = 'Backspace',
  ENTER = 'Enter',
}

export const CONFIRMATION_CODE_LENGTH = 7

export const EXPIRATION_INTERVAL_DAYS = 90

export enum accountPermissions {
  ReadAccountsBasic = 'Your account name, currency and nickname',
  ReadAccountsDetail = 'Your account name, number and sort-code',
  ReadBalances = 'Your account balance',
  ReadBeneficiariesBasic = 'Your account beneficiaries',
  ReadBeneficiariesDetail = 'Your account beneficiaries details',
  ReadDirectDebits = 'Your Direct Debits',
  ReadStandingOrdersBasic = 'Your standing orders',
  ReadStandingOrdersDetail = 'Your standing orders details',
  ReadTransactionsBasic = 'Your transactions',
  ReadTransactionsDetail = 'Details of your transactions',
  ReadTransactionsCredits = 'Details of your incoming transactions',
  ReadTransactionsDebits = 'Details of your outgoing transactions',
  ReadStatementsBasic = 'Your statements',
  ReadStatementsDetail = 'Your statements details',
  ReadProducts = 'Your products',
  ReadOffers = "Your account's promotional offers",
  ReadParty = 'Information about the account owner',
  ReadPartyPSU = 'Information about you, the logged in person',
  ReadScheduledPaymentsBasic = 'Your scheduled payments',
  ReadScheduledPaymentsDetail = 'Your scheduled payments details',
  ReadPAN = 'Your (primary) account number',
}

export const OBA_SCHEMES = {
  SortCodeAccountNumber: 'UK.OBIE.SortCodeAccountNumber',
  SortCode: 'UK.OBIE.SortCode',
  IBAN: 'UK.OBIE.IBAN',
}

export const OBA_FREQUENCIES = {
  EvryDay: 'EvryDay',
  IntrvlWkDay: 'IntrvlWkDay',
  IntrvlMnthDay: 'IntrvlMnthDay',
}

export const SCHEME_FORMATS = {
  [OBA_SCHEMES.SortCodeAccountNumber]: (string: string) =>
    // 00000012345678 => 00-00-00 12345678
    string.replace(/^(\d{2})(\d{2})(\d{2})(.*)$/g, '$1-$2-$3 $4'),
  [OBA_SCHEMES.SortCode]: (string: string) =>
    // 000000 => 00-00-00
    string.replace(/^(\d{2})(\d{2})(\d{2})$/g, '$1-$2-$3'),
  [OBA_SCHEMES.IBAN]: (string: string) =>
    // GB74REVO00996977527724 => GB74 REVO 0099 6977 5277 24
    // LT503346756485733948 => LT50 3346 7564 8573 3948
    string.replace(/(.{4})/g, '$1 ').trim(),
}

export const APM_ICONS = {
  [ApmProvider.IDEAL]: cdnLink('open-banking/iDEAL.svg'),
}

export const APM_NAMES = {
  [ApmProvider.IDEAL]: 'iDEAL',
}
